import React from 'react';
import { GridListStyle } from '../styles';
import { GridListOption } from '.';
import { useSlideData } from '@context/slide-data';

const GridList = ({ options }) => {
    const { desktop } = useSlideData();

    return (
        <GridListStyle desktop={desktop}>
            { options.map((option, index) => (
                <GridListOption option={option} key={index} />
            ))}
        </GridListStyle>
    );
};

export default GridList;
